import React from 'react';
import { connect } from 'react-redux';
import { PatientCareCenterNoteSection } from 'PatientCareCenter/Note';
import styles from './Pain.module.css';
import { DBDropDown } from '_components';


class PatientCareCenterNoteWpSubjectivePain extends React.Component {

    render() {
        return (
            <PatientCareCenterNoteSection id='sub_pain' name='Pain Rating' level={5}>
                <div className={styles.rating_row}>
                <label className={styles.rating_label_req}>Best:</label>
                    <DBDropDown
                        className={styles.rating_drop_down}
                        noteId={this.props.noteId}
                        entity='PTEVAL'
                        entityKeyColumn='EVNO'
                        entityKeyValue={this.props.evno}
                        field='EVSUBPAINBEST'
                        masterEntity='PTMASTERPAINRATING'
                        masterEntityKeyColumn='PRNO'
                        masterEntitySort='PRORDER'
                        masterEntityDisplay='PRNAME'
                    />
                         
                    <label className={styles.rating_label_req}>Worst:</label>
                    <DBDropDown
                        className={styles.rating_drop_down}
                        noteId={this.props.noteId}
                        entity='PTEVAL'
                        entityKeyColumn='EVNO'
                        entityKeyValue={this.props.evno}
                        field='EVSUBPAINWORST'
                        masterEntity='PTMASTERPAINRATING'
                        masterEntityKeyColumn='PRNO'
                        masterEntitySort='PRORDER'
                        masterEntityDisplay='PRNAME'
                    />
                    <label className={styles.rating_label_req}>Current:</label>
                    <DBDropDown
                        className={styles.rating_drop_down}
                        noteId={this.props.noteId}
                        entity='PTEVAL'
                        entityKeyColumn='EVNO'
                        entityKeyValue={this.props.evno}
                        field='EVSUBPAINCURRENT'
                        masterEntity='PTMASTERPAINRATING'
                        masterEntityKeyColumn='PRNO'
                        masterEntitySort='PRORDER'
                        masterEntityDisplay='PRNAME'
                    />
               
                </div>

            </PatientCareCenterNoteSection>
        );
    }

}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let evno = parseInt(noteId.split("_")[1]);

    return {
        noteId,
        evno
    };
}
const connectedPatientCareCenterNoteWpSubjectivePain = connect(mapStateToProps)(PatientCareCenterNoteWpSubjectivePain);
export { connectedPatientCareCenterNoteWpSubjectivePain as PatientCareCenterNoteWpSubjectivePain };

